module.exports = __webpack_public_path__ + "static/img/money2.c9badbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/icons/money2.png
// module id = aa6f
// module chunks = 2